"use client";

import Button from "../atoms/button";
import Icon from "../atoms/icon";
import Link from "../atoms/link";

import useDropdown from "@/hooks/useDropdown";

const options = [
  {
    title: "Edit",
    url: "#"
  },
  {
    title: "Delete",
    url: "#"
  },
  {
    title: "Share",
    url: "#"
  }
];
/**
 * @name OptionsVertical
 * @description Renders a vertical 3-dots menu with options.
 *
 * @param {OptionsVerticalProps} props - Component props.
 * @param {boolean} [props.fromBottom] - Whether the dropdown should open from the bottom.
 * @returns {JSX.Element} The rendered vertical options menu component.
 */

export interface OptionsVerticalProps {
  fromBottom?: boolean;
}
const OptionsVertical = ({ fromBottom }: OptionsVerticalProps) => {
  const { open, ref, toggleOpen } = useDropdown();
  return (
    <div className="relative top-0 " ref={ref}>
      <Button action={toggleOpen} className="p-1 bg-transparent">
        <Icon name="ellipsis-vertical" className="fa-solid cursor-pointer" />
      </Button>
      <ul
        className={`${open ? "block" : "hidden"} absolute ${
          fromBottom ? "bottom-0" : "top-0"
        } ltr:right-5 rtl:left-5 border z-[18] dark:border-n500 min-w-[120px] p-1.5 rounded-md bg-n0 dark:bg-bg4`}
      >
        {options.map(({ title, url }) => (
          <li key={title}>
            <Link
              href={url}
              className="py-1.5 hover:bg-primary rounded-md hover:text-n30 duration-300 block px-3"
            >
              {title}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default OptionsVertical;
